<template>

  <span>
    <Bullet
      :title="gdprInfo.title"
      :status="gdprInfo.status" />
    <span v-if="legend">{{ gdprInfo.name }}</span>
  </span>

</template>

<script>
import Bullet from '@/components/Parts/Bullet'

export default {
  name: 'ConsentBullet',
  components: {
    Bullet
  },
  props: {
    gdpr: {
      type: Object,
      default: 'secondary'
    },
    legend: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    gdprInfo () {
      const consentExpires = this.gdpr.consent_expires ? this.$d(new Date(this.gdpr.consent_expires), 'short') : null
      const consentUpdated = this.gdpr.consent_status_updated ? this.$d(new Date(this.gdpr.consent_status_updated), 'short') : null

      return {
        needs: {
          name: this.$t('Needs consent'),
          title: this.$t('Needs consent'),
          status: 'secondary'
        },
        consent_required: {
          name: this.$t('Requested consent'),
          title: this.$t('Requested consent - Expires in {consentExpires}', {consentExpires: consentExpires}),
          status: 'primary'
        },
        consented: {
          name: this.$t('Consented'),
          title: this.$t('Consented - Expires in {consentExpires}', {consentExpires: consentExpires}),
          status: 'success'
        },
        declined: {
          name: this.$t('Need to remove'),
          title: this.$t('Need to remove'),
          status: 'danger'
        },
        expired: {
          name: this.$t('Expired'),
          title: this.$t('Expired in {consentUpdated}', {consentUpdated: consentUpdated}),
          status: 'warning'
        }
      }[this.gdpr.consent_status] || {}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/ConsentBullet.vue